import { Clock, CheckCircle, Truck, XCircle, AlertTriangle, PenLine } from 'lucide-react';

/**
 * Configuration centralisée des statuts de commande.
 * Inclut les 4 statuts du nouveau workflow + legacy (shipped/delivered) en lecture seule.
 */
export const ORDER_STATUS_CONFIG = {
  pending:            { label: 'En attente',                    color: 'bg-amber-100 text-amber-800',   icon: Clock },
  confirmed:          { label: 'Confirmée',                     color: 'bg-emerald-100 text-emerald-800', icon: CheckCircle },
  confirmed_modified: { label: 'Confirmée avec modifications',  color: 'bg-blue-100 text-blue-800',     icon: PenLine },
  cancelled:          { label: 'Annulée',                       color: 'bg-red-100 text-red-700',       icon: XCircle },
  // Legacy statuts — lecture seule pour les anciennes commandes
  shipped:            { label: 'Expédiée',                      color: 'bg-indigo-100 text-indigo-800', icon: Truck },
  delivered:          { label: 'Livrée',                        color: 'bg-emerald-100 text-emerald-800', icon: CheckCircle },
};

/** Renvoie la config d'un statut. Pour un statut inconnu, affiche un avertissement explicite. */
export const getStatusConfig = (status) => {
  if (ORDER_STATUS_CONFIG[status]) return ORDER_STATUS_CONFIG[status];
  return { label: `Statut inconnu (${status || '?'})`, color: 'bg-gray-200 text-gray-700', icon: AlertTriangle };
};

export const fmtPrice = (v) => v != null ? `${Number(v).toFixed(2).replace('.', ',')} €` : '—';

export const fmtDate = (iso) => {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleDateString('fr-FR', {
      day: '2-digit', month: '2-digit', year: 'numeric',
      hour: '2-digit', minute: '2-digit'
    });
  } catch {
    return iso.slice(0, 10);
  }
};

export const fmtDateLong = (iso) => {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleDateString('fr-FR', {
      day: '2-digit', month: 'long', year: 'numeric',
      hour: '2-digit', minute: '2-digit'
    });
  } catch {
    return iso.slice(0, 10);
  }
};
